import { zoneRegistry } from "mco-zone-configurations"
import { useEffect } from "react"
import { useEnableRdsKeepAlive } from "../../state/api/Environment.Hooks"

const ZonesWithPausableRdsKeepAlive = () => {
	const [isKeepAliveEnabled, enableKeepAlive] = useEnableRdsKeepAlive()

	useEffect(() => {
		if (isKeepAliveEnabled) {
			return
		}

		enableKeepAlive()
	}, [enableKeepAlive, isKeepAliveEnabled])

	if (isKeepAliveEnabled) {
		return null
	}

	return null
}

const RdsKeepAlive = () =>
	zoneRegistry.isProduction() || zoneRegistry.isDevelopment() ? null : (
		<ZonesWithPausableRdsKeepAlive />
	)

export default RdsKeepAlive
